import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';
import { setMicSelected, setOnlyInternalAudio } from '../../actions';
import MicSelector from './MicSelector';

const mapStateToProps = ({ scribeConversation: { micIdSelected, availableMics, onlyInternalAudio } }) => ({
  micIdSelected,
  availableMics,
  onlyInternalAudio,
});

export default withSnackbar(
  connect(mapStateToProps, {
    setMicSelected,
    setOnlyInternalAudio,
  })(MicSelector)
);
